/**
 * 大六壬 · 本命 / 行年
 *
 * - **本命**：出生之年的年支（取出生年年中以避开立春边界，年支稳定）。
 * - **行年**：男命 1 岁起丙寅**顺行**，女命 1 岁起壬申**逆行**，逐年递进一位；
 *   实际用**虚岁**（当前农历年 − 出生公历年 + 1）。
 * - **行年上神**：行年地支所临地盘宫之上的天盘神及其所乘天将，是断事时最常用的「类神」之一。
 *
 * 本命/行年为可选输入：调用方可给出出生年份与性别，结果随盘面一并落库，历史重放一致。
 */
import { Lunar } from 'lunar-javascript';
import { ganOf, zhiIndex, zhiOf } from './constants';
import { liuQinOfZhi } from './liuqin';
/** 计算本命与行年（含行年上神、天将、六亲、空亡） */
export function computeBenMing(input, birthYear, gender = '男') {
    const year = Math.floor(birthYear);
    if (!Number.isFinite(year) || year < 1900) {
        throw new RangeError(`出生年份不合法：${birthYear}（应为 ≥1900 的公历年）`);
    }
    const nowLunarYear = Lunar.fromDate(new Date(input.time)).getYear();
    if (year > nowLunarYear) {
        throw new RangeError(`出生年份不能晚于当前农历年（${nowLunarYear}）`);
    }
    /** 虚岁 */
    const age = nowLunarYear - year + 1;
    // 本命：取出生年年中（必落在该干支年内），年支稳定
    const mingZhiIdx = Lunar.fromDate(new Date(year, 5, 1)).getYearZhiIndexExact();
    const mingZhi = zhiOf(mingZhiIdx);
    // 行年：男 1 岁起丙寅顺行（丙=2 寅=2）；女 1 岁起壬申逆行（壬=8 申=8）
    const isMale = gender === '男';
    const ganBase = isMale ? 2 : 8;
    const zhiBase = isMale ? 2 : 8;
    const step = age - 1;
    const ganIdx = isMale ? (ganBase + step) % 10 : ((((ganBase - step) % 10) + 10) % 10);
    const zhiIdx = isMale ? (zhiBase + step) % 12 : ((((zhiBase - step) % 12) + 12) % 12);
    const shangOf = (z) => input.tianPan[z] ?? '';
    const jiangOf = (z) => input.tianJiang[z]?.jiang ?? '';
    const xingNian = `${ganOf(ganIdx)}${zhiOf(zhiIdx)}`;
    const xingNianZhi = zhiOf(zhiIdx);
    const xingNianShangShen = shangOf(zhiIdx);
    const xingNianJiang = jiangOf(zhiIdx);
    const xingNianLiuQin = liuQinOfZhi(input.dayGanIndex, zhiIndex(xingNianShangShen));
    const xingNianKong = input.kongWang.includes(xingNianShangShen);
    const mingShangShen = shangOf(mingZhiIdx);
    const mingJiang = jiangOf(mingZhiIdx);
    const text = `本命${mingZhi}（上神${mingShangShen}乘${mingJiang}）；` +
        `虚岁${age}行年${xingNian}，行年上神${xingNianShangShen}乘${xingNianJiang}` +
        `（${xingNianLiuQin}${xingNianKong ? '·落空' : ''}）。`;
    return {
        birthYear: year,
        gender,
        mingZhi,
        mingShangShen,
        mingJiang,
        age,
        xingNian,
        xingNianZhi,
        xingNianShangShen,
        xingNianJiang,
        xingNianLiuQin,
        xingNianKong,
        text,
    };
}
//# sourceMappingURL=benming.js.map